export const defaultFormProduct = () => {
    return {
        contact_id: null,
        shipment_date   : null,
        due_date: null,
        product_id: null,
        lot: null,
        observation: null,
        quantity: null
    }
}
export default {
    reservationProducts: [],
    reservationProduct: null,
    loading: false,
    error: null,
    contacts: [],
    products: [],
    form: defaultFormProduct(),
    productspagination: {
        from: null,
        to: null,
        total: null
    },
    params: {
        paginate: false,
        filter: "",
        page: 1,
        perPage: 30,
    },
    params_request: {
        product: null
    }
};



// WEBPACK FOOTER //
// ./src/modules/reservationProduct/state.js